var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45 0.606218C10.0997 0.231089 10.9003 0.231089 11.55 0.606218L18.5433 4.64378C19.193 5.01891 19.5933 5.71218 19.5933 6.46244V14.5376C19.5933 15.2878 19.193 15.9811 18.5433 16.3562L11.55 20.3938C10.9003 20.7689 10.0997 20.7689 9.45 20.3938L2.45673 16.3562C1.80699 15.9811 1.40673 15.2878 1.40673 14.5376V6.46244C1.40673 5.71218 1.80699 5.01891 2.45673 4.64378L9.45 0.606218Z",
    fill: "#FFBF58"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_624:1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5032 2.19534C10.0555 1.87648 10.7359 1.87648 11.2882 2.19534L17.2325 5.62727C17.7848 5.94613 18.125 6.5354 18.125 7.17312V14.037C18.125 14.6747 17.7848 15.264 17.2325 15.5828L11.2882 19.0148C10.7359 19.3336 10.0555 19.3336 9.5032 19.0148L3.55893 15.5828C3.00665 15.264 2.66643 14.6747 2.66643 14.037V7.17312C2.66643 6.53541 3.00665 5.94613 3.55893 5.62727L9.5032 2.19534Z",
    fill: "#FFBF58"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81674 14.7L8.35277 11.3949H6.92969L7.07062 10.413H8.46916L8.60817 9.52928H7.18509L7.31375 8.54742H8.72456L9.06807 6.30005H10.4298L10.0863 8.54742H11.4603L11.8038 6.30005H13.1533L12.822 8.54742H14.2328L14.1042 9.52928H12.7056L12.5544 10.413H13.9897L13.861 11.3949H12.438L11.9019 14.7H10.5525L11.0762 11.3949H9.70223L9.17847 14.7H7.81674ZM9.79409 10.4376H11.2172L11.3807 9.50472H9.95763L9.79409 10.4376Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_624:1404",
    x: 2.66602,
    y: 1.95618,
    width: 15.459,
    height: 17.2977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.735
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.474486 0 0 0 0 0.172389 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_624:1404"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexcoin);
export default __webpack_public_path__ + "static/media/Hexcoin.e9f670b5.svg";
export { ForwardRef as ReactComponent };